module.exports = __webpack_public_path__ + "69a16da7ca18a94477e6d841079ca1e9.svg";